import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { useDismissibleBanner } from "hooks/use-dismissible-banner.hook";

const BANNER_KEY = "suno_scribe_custom_context_banner_v1_";

export const CONTEXT_INFO_TEXT =
  "You can add custom context to this recording — for example, Patient Information or an Audiology Report Summary. This information will be included in Scribe generation context.";

type ScribeCustomContextInfoBannerProps = {
  userId?: number;
};

export default function ScribeCustomContextInfoBanner({
  userId
}: Readonly<ScribeCustomContextInfoBannerProps>) {
  const { visible: bannerVisible, dismiss } = useDismissibleBanner({
    storageKey: BANNER_KEY,
    userId: userId != null ? String(userId) : "",
    enabled: userId != null,
    datadogActions: {
      shown: "scribe_custom_context_banner_shown",
      dismissed: "scribe_custom_context_banner_dismissed"
    }
  });

  const showBanner = userId != null && bannerVisible;

  if (!showBanner) {
    return null;
  }

  return (
    <Box sx={{ flexShrink: 0, width: "calc(100% - 32px)" }}>
      <Alert
        severity="info"
        sx={{ mt: 2, width: "100%" }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => dismiss({ source: "banner_got_it" })}
            aria-label="Dismiss custom context announcement"
          >
            Got&nbsp;it
          </Button>
        }
      >
        {CONTEXT_INFO_TEXT}
      </Alert>
    </Box>
  );
}
